import CultureCodeEnum from '../../../../../models/culture-code-enum';
import client from '../../../client';

const favouritesLineDelete = async (
  basketId: string,
  lineId: number
): Promise<void> => {
  const { data } = await client.delete<void>('/favourites/line/delete', {
    params: { basketId, lineId, cultureCode: CultureCodeEnum.EnGb },
  });

  return data;
};

export default favouritesLineDelete;
